export const sectionContentStyles = {
  gap: '24px',

  '& .data-panel': {
    flexDirection: 'row',
    maxWidth: '1084px',
  },

  '& .data-display': {
    flex: 1,
  },
};
